import { render, staticRenderFns } from "./OverviewStatisticCard.vue?vue&type=template&id=aa3e3a1c&scoped=true"
import script from "./OverviewStatisticCard.vue?vue&type=script&lang=ts"
export * from "./OverviewStatisticCard.vue?vue&type=script&lang=ts"
import style0 from "./OverviewStatisticCard.vue?vue&type=style&index=0&id=aa3e3a1c&prod&lang=scss&scoped=true"
import style1 from "./OverviewStatisticCard.vue?vue&type=style&index=1&id=aa3e3a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3e3a1c",
  null
  
)

export default component.exports